exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".moneyCellWrapper-ae5f8{display:flex;justify-content:flex-end}.moneyCell-effa4{width:100%;overflow:hidden}", ""]);

// Exports
exports.locals = {
	"moneyCellWrapper": "moneyCellWrapper-ae5f8",
	"moneyCell": "moneyCell-effa4"
};